var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalInventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#008E8E",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H36V36H13V13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2393 30.5869V35.3262H13.6738V17.9814",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9818 13.6738H29.2392V18.4131",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9818 13.6739V17.9814H13.6738",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6738 17.9817L17.9816 13.6739",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 24.5C31 25.3284 30.3285 26 29.5 26C28.6716 26 28.0001 25.3284 28.0001 24.5C28.0001 23.6716 28.6716 23 29.5 23C30.3285 23 31 23.6716 31 24.5Z",
    fill: "#008E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3262 25.6384V23.3616L33.2952 23.1364C33.2316 22.9473 33.1551 22.7643 33.0669 22.5881L34.3405 20.9894L32.7269 19.3831L31.134 20.6638C30.9631 20.5792 30.7858 20.5055 30.6029 20.4441L30.3776 18.4131H28.1009L27.8756 20.4441C27.6866 20.5076 27.5035 20.5842 27.3273 20.6723L25.7287 19.3989L24.1224 21.0124L25.4031 22.6052C25.3185 22.7762 25.2448 22.9534 25.1834 23.1364L23.1523 23.3616V25.6384L25.1834 25.8637C25.2469 26.0527 25.3234 26.2357 25.4116 26.4119L24.1381 28.0106L25.7516 29.6169L27.3445 28.3362C27.5154 28.4208 27.6927 28.4945 27.8756 28.5559L28.1009 30.5869H30.3776L30.6029 28.5559C30.7919 28.4924 30.975 28.4158 31.1512 28.3277L32.7499 29.6012L34.3561 27.9877L33.0755 26.3948C33.16 26.2238 33.2337 26.0466 33.2952 25.8637L35.3262 25.6384Z",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 20.677H20.4569",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 23.3723H20.4569",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 26.0676H20.4569",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 28.7629H20.4569",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 31.4583H22.703",
    stroke: "#008E8E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInventory);
export default __webpack_public_path__ + "static/media/Total Inventory.a6366bffceeca64523c505ad4f15a790.svg";
export { ForwardRef as ReactComponent };